/**
 * MODULE: domain/sales-target-management/frontend/utils/salesTargetIntegrationUtils.ts
 * PURPOSE: Labels and helpers for integration-managed sales quotas
 */

import type { SalesTarget } from '../../contracts/sales-targets.types';

const SOURCE_LABELS: Record<string, string> = {
  brazn: 'Brazn',
  territory_alignment: 'Territory alignment',
  salesforce: 'Salesforce',
  hubspot: 'HubSpot',
  dynamics: 'Microsoft Dynamics',
};

export function isSalesTargetLocked(target: SalesTarget | null | undefined): boolean {
  return Boolean(target?.is_locked);
}

export function formatSalesTargetSourceLabel(source?: string | null): string {
  if (!source) return 'Brazn';
  const key = source.toLowerCase();
  return SOURCE_LABELS[key] ?? source.replace(/_/g, ' ');
}

export function salesTargetIntegrationHint(target: SalesTarget): string | null {
  if (!isSalesTargetLocked(target)) {
    if (target.source_system && target.source_system !== 'brazn') {
      return `Synced from ${formatSalesTargetSourceLabel(target.source_system)}`;
    }
    return null;
  }
  if (target.lock_reason) return target.lock_reason;
  return `Managed by ${formatSalesTargetSourceLabel(target.source_system)}. Contact your manager to request changes.`;
}
